import { PaneHeader } from '@/components/settings/pane-header';
import { BotServiceHoursEditor } from '@/components/settings/bot-hours/bot-service-hours-editor';

// Hosts the bot working-hours editor (defaults, per-WhatsApp-number and in-app overrides,
// special days, emergencies). Viewable with settings:view; canEdit comes from the payload (the
// server's settings:manage answer). The editor owns its own scroll area and save bar, so
// this shell is just the pane header on top.
export function BotServiceHoursSubPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PaneHeader
        title="Bot working hours"
        description="When the clinic chatbots answer, and what they say when the clinic is closed. Shared with your whole team."
      />
      <BotServiceHoursEditor />
    </div>
  );
}
